import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth-context";

export default function ProtectedRoute({ children }) {
    const { status } = useAuth();
    if (status === "loading") {
        return (
            <div
                data-testid="auth-loading"
                className="flex h-screen items-center justify-center text-sm text-neutral-500"
            >
                Loading…
            </div>
        );
    }
    if (status !== "authed") return <Navigate to="/login" replace />;
    return children;
}
